export default __webpack_public_path__ + "static/media/xylophone_xilofono_3.3a2e4c28.png";